export const SUCCESS = "SUCCESS_BADGE";
export const ERROR = "ERROR_BADGE";
export const CLEAR = "CLEAR_BADGE";
export const LOADING = "LOADING_BADGE";
export const GET_STATUS = "GET_STATUS_BADGE";

export function loading(loading = true) {
	return {
		type: LOADING,
		data: loading
	};
}

export function error(error) {
	return {
		type: ERROR,
		data: error
	};
}

export function success() {
	return {
		type: SUCCESS,
	};
}

export function clearCreator() {
	return {
		type: CLEAR
	};
}

export function getStatusCreator(status) {
	return {
		type: GET_STATUS,
		data: status
	};
}
